import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';


interface LastNameFieldProps {
  control: Control<FormProps>;
}

export function LastNameField({ control }: Readonly<LastNameFieldProps>) {
  return (
    <Controller
      name="lastName"
      control={control}
      rules={{ required: 'required' }}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          label="Surname"
          required
          fullWidth
          autoComplete="family-name"
          error={!!error}
          helperText={error?.message}
        />
      )}
    />
  );
}
